import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const fieldWarning: ThemeUICSSObject = {
  backgroundColor: 'warning',
  mb: '0',
  p: '2',
};

export default fieldWarning;
